<template>
    <span @click.stop="dialogVisible = true">
        <slot />
        <el-dialog v-if="dialogVisible" v-bind="$attrs" :visible="true" :class="single ? 'calcDialog' : ''" @close="onCancel" append-to-body top="5%">
            <slot v-if="dialogVisible" name="contain" class="absolute-all" />
            <span slot="footer" v-if="footer" class="dialog-footer">
                <slot name="footerBtn" />
                <el-button v-if="cancel" @click="dialogVisible = false">
                    取 消
                </el-button>
                <el-button v-if="ok" @click="submit" type="primary">
                    确 定
                </el-button>
            </span>
        </el-dialog>
    </span>
</template>

<script>
export default {
    props: {
        footer: { type: Boolean, default: false },
        cancel: { type: Boolean, default: true },
        ok: { type: Boolean, default: true },
        single: { type: Boolean, default: false },
        outClose: { type: [Boolean, String, Number], default: true }
    },
    data() {
        return {
            dialogVisible: false
        };
    },
    watch: {
        outClose() {
            this.onCancel();
        }
    },
    methods: {
        // 点击取消按钮
        onCancel() {
            this.dialogVisible = false;
            this.$emit('cancel');
        },
        submit() {
            this.dialogVisible = false;
            this.$emit('ok');
        }
    }
};
</script>
